import { apiSlice } from "./apiSlice"
import API from "../utils/API";

export function getInitialData(style = 34) {
    return API.getHome(style)
    .then(res => {
        return res.data
    })
    .catch(err => console.log(err))
}

export function getDiscoverData(style = 34) {
    return API.getDiscover(style)
    .then(res => {
        return res.data
    })
    .catch(err => console.log(err))
}

export function getSearchByTerm(term) {
    return API.getSearch(term)
    .then(res => {
        return res.data
    })
    .catch(err => console.log(err))
}


export const discoverApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getStyles: builder.query({
            query: (country = 'FR') => `/styles/store/${country}`,
        }),
        getSearch: builder.query({
            query: (term) => `/search?s=${term}`,
        }),
        getDiscover: builder.query({
            query: ({style = 34, country = 'FR'}) => `/v1/discover/${style}/${country}`,
        }),
        getProducers: builder.query({
            query: ({style = 34, country = 'FR'}) => `/v1/discover/top/producers/${style}/${country}`,
            providesTags: (res = []) => [
                ...res.map(( artist ) => ({ type: 'Artist', id: artist._id}))
            ]
        }),
        getInterpretors: builder.query({
            query: ({style = 34, country = 'FR'}) => `/v1/discover/top/interpretors/${style}/${country}`,
            providesTags: (res = []) => [
                ...res.map(( artist ) => ({ type: 'Artist', id: artist._id}))
            ]
        }),
        getAlbums: builder.query({
            query: ({style = 34, country = 'FR'}) => `/v1/discover/top/albums/${style}/${country}`,
        }),
        getNewTracks: builder.query({
            query: ({style = 34, country = 'FR'}) => `/v1/discover/top/news/${style}/${country}`,
        }),
        getBestsTracks: builder.query({
            query: ({style = 34, country = 'FR'}) => `/v1/discover/top/bests/${style}/${country}`,
        }),
        getLabels: builder.query({
            query: ({style = 34, country = 'FR'}) => `/v1/discover/top/labels/${style}/${country}`,
        }),
        getPlaylists: builder.query({
            query: (country = 'FR') => `/v1/discover/top/playlists/${country}`,
        })
    })
})


export const {
    useGetDiscoverQuery,
    useGetProducersQuery,
    useGetSearchQuery,
    useGetInterpretorsQuery,
    useGetAlbumsQuery,
    useGetNewTracksQuery,
    useGetLabelsQuery,
    useGetStylesQuery,
    useGetBestsTracksQuery,
    useGetPlaylistsQuery
} = discoverApiSlice 